import { Component, Element, Host, h, Prop } from "@stencil/core";

/**
 * @slot title - Slot for the headline (`<h2>` or `<h3>`)
 * @slot subtitle - Slot for the subtitle (`<p>` or `<div>`)
 * @slot (default) - Slot for the benefits list (`<ul>` and `<li>`)
 */
@Component({
    tag: "ux-iws-nb-product-benefits",
    styleUrl: "nb-product-benefits.scss",
    shadow: false,
})
export class NbProductBenefits {
    private static uidIncrement = 0;
    private uid = `nb-product-benefits-${NbProductBenefits.uidIncrement++}`;

    /**
     * The element reference for the component.
     * Used to access the DOM and manipulate styles or classes.
     */
    @Element() host: HTMLUxIwsNbProductBenefitsElement;

    /** Variant of the component */
    @Prop() variant: "light" | "light-gray" | "dark-blue" = "light";

    render() {
        const baseClass = "ux-iws-nb-product-benefits";
        return (
            <Host
                class={{
                    [baseClass]: true,
                    [`${baseClass}--${this.variant}`]: !!this.variant,
                }}
            >
                <article
                    class={`${baseClass}__article`}
                    aria-labelledby={`${this.uid}-title`}
                >
                    <div class={`${baseClass}__title`} id={`${this.uid}-title`}>
                        <slot name="title" />
                        <slot name="subtitle" />
                    </div>
                    <div class={`${baseClass}__list`} id={`${this.uid}-list`}>
                        <slot />
                    </div>
                </article>
            </Host>
        );
    }
}
